module.exports = __webpack_public_path__ + "static/media/en-share-image.d79bc1c4.jpg";